import store from '@/store/index';
import { SESSION } from '@/store/modules.type';
import { GET_USER_ID } from '@/store/session/getters.type';

export default {
  install(Vue) {
    Vue.mixin({
      computed: {
        $currentUser() {
          return store.state.session.user;
        },
        $currentUserId() {
          return store.getters[`${SESSION}/${GET_USER_ID}`];
        },
        $currentUsername() {
          return store.getters['session/username'];
        },
      },
    });
  },
};
